export default "/assets/images/mila-feed-03.53af05047c617407.mp4";